import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";

// --- Styled Components ---

const PMUSection = styled.section`
  padding: 120px 20px;
  /* background-color: #f9f6f3; */
  display: flex;
  justify-content: center;
  overflow: hidden;
`;

const ContentWrapper = styled.div`
  display: grid;
  grid-template-columns: 1.2fr 0.8fr;
  gap: 60px;
  width: 100%;
  max-width: 1200px;
  align-items: start;

  @media (max-width: 968px) {
    grid-template-columns: 1fr;
  }
`;

const PriceListSide = styled(motion.div)`
  display: flex;
  flex-direction: column;
`;

const HeaderLabel = styled.span`
  text-transform: uppercase;
  letter-spacing: 4px;
  font-size: 0.9rem;
  color: #a38d92;
  margin-bottom: 10px;
`;

const MainTitle = styled.h2`
  font-family: "Lovelace", serif;
  font-style: italic;
  font-size: clamp(3rem, 6vw, 5rem);
  font-weight: 400;
  color: #1a1a1a;
  margin: 0 0 50px 0;
  line-height: 1;
`;

const ServiceRow = styled(motion.div)`
  display: flex;
  justify-content: space-between;
  padding: 25px 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);

  .label-group {
    display: flex;
    flex-direction: column;
    gap: 5px;
  }

  .name {
    font-size: 1.5rem;
    color: #1a1a1a;
  }

  .sub {
    font-size: 0.9rem;
    color: #8e7479;
    text-transform: uppercase;
  }

  .price {
    font-family: "Lovelace", serif;
    font-size: 1.5rem;
    font-weight: 700;
  }
`;

const InfoCard = styled(motion.div)`
  background: rgba(110, 86, 62, 0.308);
  color: white;
  padding: 50px;
  border-radius: 40px;
  position: sticky;
  top: 100px;
  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.15);

  h4 {
    font-family: "Lovelace", serif;
    font-size: 2rem;
    margin-bottom: 20px;
    font-style: italic;
  }

  p {
    line-height: 1.8;
    font-size: 1.05rem;
    opacity: 0.9;
  }
`;

// --- Animation Config ---

const fadeInUp = {
  hidden: { opacity: 0, y: 40 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, ease: [0.16, 1, 0.3, 1] },
  },
};

const staggerContainer = {
  visible: { transition: { staggerChildren: 0.1 } },
};

// --- Component ---

const PermanentMakeUp = () => {
  return (
    <PMUSection>
      <ContentWrapper>
        {/* Left Side: Prices */}
        <PriceListSide
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
        >
          <HeaderLabel>Simona PMU Master</HeaderLabel>
          <MainTitle>Augenbrauen</MainTitle>

          <ServiceRow variants={fadeInUp}>
            <div className="label-group">
              <span className="name">Erstbehandlung</span>
              <span className="sub">Für alle Hauttypen geeignet</span>
            </div>
            <span className="price">€ 290</span>
          </ServiceRow>

          <ServiceRow variants={fadeInUp}>
            <div className="label-group">
              <span className="name">Nachbehandlung</span>
              <span className="sub">Bis 2 Monate</span>
            </div>
            <span className="price">€ 110</span>
          </ServiceRow>

          <ServiceRow variants={fadeInUp}>
            <div className="label-group">
              <span className="name">Nachbehandlung</span>
              <span className="sub">Bis 2 Jahre</span>
            </div>
            <span className="price">€ 160</span>
          </ServiceRow>

          <ServiceRow variants={fadeInUp}>
            <div className="label-group">
              <span className="name">Auffrischung</span>
              <span className="sub">Ab 2-3 Jahre</span>
            </div>
            <span className="price">€ 190</span>
          </ServiceRow>
        </PriceListSide>

        {/* Right Side: Sticky Info */}
        <InfoCard
          initial={{ opacity: 0, x: 50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 1, delay: 0.3 }}
          viewport={{ once: true }}
        >
          <h4>Gut zu wissen</h4>
          <p>
            Ein Beratungsgespräch ist bei mir immer kostenfrei. Je nach Hauttyp
            hält das PMU 2-3 Jahre. Ich wende eine natürliche Technik an, die
            nur in die Epidermis gestochen wird, um plakative oder bläuliche
            Ergebnisse auszuschließen.
          </p>
          {/* <motion.button
            style={{
              marginTop: "30px",
              padding: "15px 30px",
              borderRadius: "50px",
              border: "none",
              background: "#f9f6f3",
              color: "#1a1a1a",
              fontFamily: "Montserrat",
              cursor: "pointer",
              fontWeight: 600,
            }}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Termin buchen
          </motion.button> */}
        </InfoCard>
      </ContentWrapper>
    </PMUSection>
  );
};

export default PermanentMakeUp;
